import ReactDOM from "react-dom/client";
import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";
import NotificationEventTypes from "../../constants/notificationEventsEnum";
import { useWorkflow } from "../../context/WorkflowContext";
import WorkflowActionTypes from "../../constants/workflowActionsEnum";

function AssessmentDateModal({
  onClose,
  firstRegistrationId,
  code,
  selectedClass,
  refreshOnSubmitSuccess,
}) {
  // console.log(selectedClass);

  const token = localStorage.getItem("token");
  const centerId = localStorage.getItem("centerId");
  const userId = localStorage.getItem("userId");

  const [isEditMode, setIsEditMode] = useState(false);
  const [isReschedule, setIsReschedule] = useState(false);
  const [createdBy, setCreatedBy] = useState("");
  const [slotsData, setSlotsData] = useState([]);
  const [assessmentDate, setAssessmentDate] = useState("");
  const [classesData, setClassesData] = useState([]);
  const [teachersData, setTeachersData] = useState([]);
  // const [selectedClassId, setSelectedClassId] = useState(selectedClass);
  const [isLoadingClasses, setIsLoadingClasses] = useState(true);

  const { workflowParams } = useWorkflow();

  const toggleReschedule = () => {
    setIsReschedule((prevState) => !prevState);
  };

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      assessmentDate: "",
      assessmentSlotId: null,
      reason: "",
      remarks:
        "Pupil Assessment for registration no:" + code + "has been scheduled",
      // centerClassId: null,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
    },
  });

  useEffect(() => {
    const fetchClassesByCenterId = async () => {
      try {
        setIsLoadingClasses(true); // Ensure loader is shown on every modal open
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);

        if (selectedClass) {
          const selectedClassData = response.find(
            (classItem) => classItem.id === selectedClass
          );

          if (selectedClassData) {
            setValue("centerClassId", selectedClassData.name);

            // setValue("centerClassId", {
            //   value: selectedClassData.id,
            //   label: selectedClassData.name,
            // });
            // setSelectedClassId(selectedClassData.id);
          }
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      } finally {
        setIsLoadingClasses(false);
      }
    };

    fetchClassesByCenterId();
  }, [selectedClass]); // Added dependencies to ensure effect runs on modal open

  const getUsersByCenterIdAndRoleId = async () => {
    try {
      const response = await get(
        `UserAuthentication/GetUsersByCenterClassAndRoleId?centerId=${centerId}&roleId=${7}&classId=${selectedClass}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTeachersData(response);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  useEffect(() => {
    if (selectedClass) {
      getUsersByCenterIdAndRoleId();
    }
  }, [selectedClass]);

  const fetchScheduleDetails = async () => {
    try {
      const response = await get(
        `CommonSettings/GetScheduleLogByScheduleTypeWithTeacherAndIdActiveRecordAsync?ScheduleType=Assessment&studentFirstRegistrationId=${firstRegistrationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.scheduleLog?.id && response.scheduleLog.id !== 0) {
        const scheduleData = response.scheduleLog;

        setCreatedBy(scheduleData.createdBy);
        setAssessmentDate(scheduleData.scheduleDate);
        setIsEditMode(true);

        const centerClassesResponse = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(centerClassesResponse);

        const selectedCenterClass = centerClassesResponse.find(
          (item) => item.id === scheduleData.centerClassId
        );

        const teachersResponse = await get(
          `UserAuthentication/GetUsersByCenterClassAndRoleId?centerId=${centerId}&roleId=${7}&classId=${
            scheduleData.centerClassId
          }`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setTeachersData(teachersResponse);

        const selectedTeachers = scheduleData.scheduleLogTeacherEmailDtos?.map(
          (t) => {
            const teacherInfo = teachersResponse.find(
              (td) => td.id === t.userId
            );

            return {
              value: t.userId,
              label: teacherInfo
                ? teacherInfo.firstName + " " + teacherInfo.lastName
                : `Teacher ${t.userId}`,
            };
          }
        );

        reset({
          id: scheduleData.id,
          // centerClassId: selectedCenterClass
          //   ? { value: selectedCenterClass.id, label: selectedCenterClass.name }
          //   : null,
          assessmentDate: scheduleData.scheduleDate?.split("T")[0],
          assessmentSlotId: {
            value: scheduleData.slotId,
            label: scheduleData.slotName,
          },
          reason: scheduleData.reason,
          communicationRemarks: scheduleData.remarks,
          emails: scheduleData.emails,
          teacherId: selectedTeachers,
        });
      } else {
        setIsEditMode(false);
        reset({
          assessmentDate: "",
          assessmentSlotId: null,
          reason: "",
          communicationRemarks:
            "Pupil Assessment for registration no: " +
            code +
            " has been scheduled",
          // centerClassId: null,
          createdBy: localStorage.getItem("userId"),
          updatedBy: localStorage.getItem("userId"),
        });
      }
    } catch (error) {
      console.error("Error fetching schedule data", error);
    }
  };

  useEffect(() => {
    if (firstRegistrationId) {
      fetchScheduleDetails();
    }
  }, [firstRegistrationId]);

  useEffect(() => {
    if (assessmentDate) {
      fetchAssessmentSlots();
    }
  }, [assessmentDate]);

  const fetchAssessmentSlots = async () => {
    try {
      const response = await get(
        `CommonSettings/GetTimeSlotByDateAndSlotTypeAsync?date=${assessmentDate}&slotType=${"Assessment"}&centerId=${centerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSlotsData(response?.timeSlot);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const saveAssessment = async (data) => {
    const selectedTeachers = data.teacherId || [];

    const formData = {
      studentFirstRegistrationId: firstRegistrationId,
      FormId: 76,
      NotificationEventTypeIds: isReschedule
        ? NotificationEventTypes.UPDATE.toString()
        : NotificationEventTypes.ADD.toString(),
      scheduleLogDtos: {
        id: isEditMode ? data.id : 0,
        studentFirstRegistrationId: firstRegistrationId,
        centerClassId: selectedClass,
        scheduleType: "Assessment",
        scheduleDate: data.assessmentDate,
        slotId: data.assessmentSlotId?.value || 0,
        slotName: data.assessmentSlotId?.label || "",
        remarks: data.communicationRemarks,
        isReschedule: isReschedule,
        reason: isReschedule ? data.reason : "",
        emails: data.emails || "",
        createdBy: isEditMode
          ? createdBy || localStorage.getItem("userId")
          : localStorage.getItem("userId"),
        updatedBy: localStorage.getItem("userId"),
      },
      scheduleLogTeacherEmailDtos: selectedTeachers.map((teacher) => ({
        id: 0,
        userId: teacher.value,
        scheduleLogId: 0,
      })),
      Workflow: {
        ...workflowParams.Workflow,
        WorkflowStepId: workflowParams.Workflow.WorkflowStepId,
        CreatedBy: Number(userId),
      },
    };

    // try {
    //   const response = await post(
    //     "CommonSettings/AddUpdateAssessmentScheduleLogAsync",
    //     formData,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   if (response.isSuccess) {
    //     toast.success("Success!");
    //     onClose();
    //     refreshOnSubmitSuccess();
    //   }
    // }

    try {
      const response = await post(
        "CommonSettings/AddUpdateAssessmentScheduleLogAsync",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        const assignStepPayload = {
          StepAssignmentToUsersList: selectedTeachers.map((teacher) => ({
            ProcessId: workflowParams.Workflow.WorkflowProcessId,
            DBObjectId: workflowParams.Workflow.DBObjectId,
            DBObjectLocationId: workflowParams.Workflow.DBObjectLocationId,
            StepId: workflowParams.Workflow.WorkflowStepId,
            ActionId: WorkflowActionTypes.Schedule,
            UserId: teacher.value,
          })),
        };

        const assignResponse = await post(
          "workflow/assignStepToMultipleUsers",
          assignStepPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (assignResponse.success) {
          toast.success("Success!");
          onClose();
          refreshOnSubmitSuccess();
        } else {
          toast.error(
            "Failed to assign step to teachers: " + assignResponse.message
          );
        }
      } else {
        toast.error("Failed to schedule assessment: " + response.message);
      }
    } catch (error) {
      console.error("Error saving assessment date", error);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Schedule Assessment</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(saveAssessment)}
              >
                <div className="col-md-4">
                  <label className="form-label form-label-new">Class</label>
                  <input
                    type="text"
                    {...register("centerClassId", {})}
                    className="form-control"
                    disabled={true}
                  />
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div>
                {/* <div className="col-md-4">
                  <label className="form-label form-label-new">
                    Class<span className="text-danger fs-9">*</span>
                  </label>
                  {isLoadingClasses ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <Controller
                      name="centerClassId"
                      control={control}
                      rules={{ required: "This field is required." }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={classesData.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.name,
                          }))}
                          onChange={(selectedOption, actionMeta) => {
                            if (actionMeta.action === "clear") {
                              setValue("centerClassId", null);
                              // setSelectedClassId(0);
                            } else {
                              setValue("centerClassId", selectedOption);
                              // setSelectedClassId(selectedOption.value);
                            }
                            trigger("centerClassId");
                            setValue("teacherId", []);
                            setTeachersData([]);
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                          isClearable
                          isDisabled={true}
                        />
                      )}
                    />
                  )}
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div> */}
                <div className="col-md-8">
                  <label className="form-label form-label-new">
                    Teacher<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="teacherId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isMulti
                        options={teachersData.map((teacher) => ({
                          value: teacher.id,
                          label: `${teacher.firstName} ${teacher.lastName}`,
                        }))}
                        onChange={(selectedOptions, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("teacherId", []);
                          } else {
                            setValue("teacherId", selectedOptions);
                          }
                          trigger("teacherId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        closeMenuOnSelect={false}
                        isClearable
                        isDisabled={isEditMode && !isReschedule}
                      />
                    )}
                  />
                  {errors.teacherId && (
                    <small className="text-danger">
                      {errors.teacherId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Additional Email(s)
                  </label>
                  <input
                    type="text"
                    {...register("emails", {
                      validate: (value) => {
                        if (!value) return true;
                        const emails = value
                          .split(",")
                          .map((email) => email.trim());
                        const emailPattern =
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        const allValid = emails.every((email) =>
                          emailPattern.test(email)
                        );
                        return allValid || "Invalid email format";
                      },
                    })}
                    className="form-control"
                    disabled={isEditMode && !isReschedule}
                  />
                  <div className="fs-10 text-black-50">(comma separated)</div>
                  {errors.emails && (
                    <small className="text-danger">
                      {errors.emails.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Assessment Date<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    type="date"
                    {...register(`assessmentDate`, {
                      required: "This field is required.",
                    })}
                    className="form-control"
                    onChange={(e) => {
                      setAssessmentDate(e.target.value);
                      setValue("assessmentSlotId", null);
                    }}
                    disabled={isEditMode && !isReschedule}
                  />
                  {errors.assessmentDate && (
                    <small className="text-danger">
                      {errors.assessmentDate.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Time Slot<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="assessmentSlotId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={slotsData?.map((slot) => ({
                          value: slot.id,
                          label: slot.fromTime + " " + slot.toTime,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("assessmentSlotId", null);
                          } else {
                            setValue("assessmentSlotId", selectedOption);
                          }
                          trigger("assessmentSlotId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                        isDisabled={isEditMode && !isReschedule}
                      />
                    )}
                  />
                  {errors.assessmentSlotId && (
                    <small className="text-danger">
                      {errors.assessmentSlotId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Remarks<span className="text-danger fs-9">*</span>
                  </label>
                  <textarea
                    {...register(`communicationRemarks`, {
                      required: "This field is required.",
                    })}
                    className="form-control"
                    disabled={isEditMode && !isReschedule}
                  ></textarea>
                  {errors.communicationRemarks && (
                    <small className="text-danger">
                      {errors.communicationRemarks.message}
                    </small>
                  )}
                </div>
                {isEditMode && isReschedule && (
                  <div className="col">
                    <label className="form-label form-label-new">
                      Reschedule Reason
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <textarea
                      {...register("reason", {
                        required: "This field is required.",
                      })}
                      className="form-control"
                    ></textarea>
                    {errors.reason && (
                      <small className="text-danger">
                        {errors.reason.message}
                      </small>
                    )}
                  </div>
                )}

                <div className="d-flex gap-2 justify-content-end">
                  {isEditMode && (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={toggleReschedule}
                      >
                        {isReschedule ? "Cancel" : "Reschedule"}
                      </button>
                    </>
                  )}
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Save</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default AssessmentDateModal;
